import LoadingIcon from "@/assets/common/ic-loading.png";
import "./index.less";

interface LoadingProps {
  className?: string;
  src?: string;
}

const CommonLoading = ({ className, src }: LoadingProps) => (
  <div className={`loading ${className}`}>
    <img src={src || LoadingIcon} />
  </div>
);

export default CommonLoading;
